@import (reference) '../../../../../constants/spacing.module.less';

.cost-summary-container {
  padding: @space-16;
  background-color: var(--white);
}

.cost-summary-header {
  margin-bottom: @space-12;
}

.cost-summary-values {
  align-items: flex-end;
}

.cost-summary-row {
  justify-content: flex-end;
}

.cost-summary-label {
  font-weight: 600;
  font-size: 14px;
  color: var(--grey-700);
}

.cost-summary-value {
  font-weight: 600;
  font-size: 14px;
  width: 120px;
  text-align: right;
}

.received-divider {
  margin: @space-12 0 @space-12 auto;
  width: 350px;
  border-top: 1px solid var(--grey-300);
}

.cost-summary-values-received {
  align-items: flex-end;
}

.cost-summary-label-received {
  font-size: 14px;
  color: var(--grey-600);
}

.cost-summary-value-received {
  font-size: 14px;
  color: var(--grey-600);
  width: 120px;
  text-align: right;
}
